/**
 * @description
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    content: string;
    ref_type: string;
    ref_id: number;
    top_section_id: number;
}
interface IOutput {
    top_section_id: number;
}

export const updateMultimedia = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.UPDATE_MULTIMEDIA, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
